// extracted by mini-css-extract-plugin
module.exports = {"gradient_ball":"styles_gradient_ball__3IL8Z","small":"styles_small__1wXyE","medium":"styles_medium__2wmck","large":"styles_large__1p7zt"};